var lx = lx || {};

lx.topMenu = {
    profile: null,
    profileSearchMin: 3,
    msg: null,
    notify: null,
    title: {"P":"Profile","M":"Messages","N":"Notifications","S":"Search","SP":"Support"},
    loading: "Loading...",
    opened: "",
    fetchInProgress: false,
    observeMoreMsg: new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                lx.topMenu.getData('M', lx.topMenu.msg.rows.length);
                //console.log("msgObserver fire!");
            }
        }, {root: document.querySelector(".lxTop_M .lxTop")}
    ),
    observeMoreNotify: new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                //console.log("Load More");
                lx.topMenu.getData('N', lx.topMenu.notify.rows.length);
            }
        }, {root: document.querySelector(".lxTop_N .lxTop")}
    ),
    observeMoreSearch: new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                //console.log("Load More");
                lx.topMenu.getData('S', lx.topMenu.search.rows.length);
            }
        }, {root: document.querySelector(".lxTop_S .lxTop")}
    ),
    outsideClickListener: (event) => {
        var selector = ".lxTop_" + lx.topMenu.opened;
        $target = $(event.target);
        if (!$target.closest(selector).length && $(selector).is(':visible')) {
            lx.topMenu.removeClickListener();
        }
    },
    removeClickListener: () => {
        document.removeEventListener('click', lx.topMenu.outsideClickListener);
        var $menu = $(".lxTop_"+ lx.topMenu.opened);
        $menu.find(".t-Button").removeClass("is-active");
        $menu.find(".lxTop").hide();
        lx.topMenu.opened = "";
    },
    refresh: (pMenu) => {
        var $menu = $(".lxTop_"+ pMenu);
        var $menuDiv = $menu.find(".lxTop");
        if ($menuDiv.length > 0) {
            $menuDiv.remove();
        }
        setTimeout( () => lx.topMenu.open(pMenu), 1000);
    },
    reset: (pMenu) => {
        lx.topMenu.removeClickListener();
        $(".lxTop_"+ pMenu +" .lxTop").remove();
    },
    open: function (pMenu, pFromFetch){
        var menu = pMenu;
        var $menu = $(".lxTop_"+ menu);
        var $menuDiv = $menu.find(".lxTop");

        if (lx.topMenu.fetchInProgress) {
            return;
        } else if (menu != lx.topMenu.opened){
            lx.topMenu.removeClickListener();
        }

        if ($menuDiv.is(":visible")) {
            lx.topMenu.removeClickListener();
            return;
        } else if ($menuDiv.length > 0) {
            lx.topMenu.opened = menu;
            $menuDiv.show();
        } else if (pFromFetch){
            var lTopMenu = "";
            var lBtns;
            switch (menu) {
                case 'P':   lTopMenu = lx.topMenu.genProfile();
                            lBtns = lx.topMenu.profile.btn; break;
                case 'M':   lTopMenu = lx.topMenu.genMsg();
                            lBtns = lx.topMenu.msg.btn; break;
                case 'N':   lTopMenu = lx.topMenu.genNotify();
                            lBtns = lx.topMenu.notify.btn; break;
                case 'S':   lTopMenu = lx.topMenu.genSearch();
                            lBtns = lx.topMenu.search.btn; break;
                case 'SP':  lTopMenu = lx.topMenu.genSupport();
                            lBtns = lx.topMenu.support.btn; break;
                default: return;
            }
            // generate buttons
            var lBtnsHTML = "";
            var lContentBtnsHTML = "";
            if (lBtns) {
                for (let j = 0; j < lBtns.length; j++) {
                    if (lBtns[j].id == "inviteUsersBtn") lContentBtnsHTML += lx.btn.gen( lBtns[j] );
                    else lBtnsHTML += lx.btn.gen( lBtns[j] );
                }
                lBtnsHTML = '<div class="btnContainer">'+ lBtnsHTML +'</div>';
            }
            // form complete dropdown html
            lTopMenu = '<div class="lxTop"><div class="hdr">'+ lBtnsHTML +'</div><div class="content">'+ lContentBtnsHTML + lTopMenu +'</div></div>'; /*<h1>'+ lx.topMenu.title[menu] +'</h1>*/
            $menu.append(lTopMenu);
            lx.topMenu.opened = menu;
            
            
            switch (menu) {
                case 'M':  if ( lx.topMenu.msg.rows.length > 0 ) lx.topMenu.observeMoreMsg.observe( document.querySelector("#loadMoreM") ); break;
                case 'N':  lx.topMenu.observeMoreNotify.observe( document.querySelector("#loadMoreN") ); break;
                //case 'S':  lx.topMenu.observeMoreSearch.observe( document.querySelector("#loadMoreS") ); break;
                default: break;
            }
        } else {
            lx.topMenu.getData(menu);
            return;
        }

        $menu.find(".t-Button--navBar").addClass("is-active");
        document.addEventListener('click', lx.topMenu.outsideClickListener);
    
        if ($(document).width() > 640){
            if (menu == 'P' && lx.topMenu.profile.rows.length >= lx.topMenu.profileSearchMin) setTimeout(function(){ $("#topMenuProfileTerm").focus(); }, 100);
            else if (menu == 'S') setTimeout(function(){ $("#topMenuSearchTerm").focus(); }, 100);
            else if (menu == 'M') setTimeout(function(){ $("#topMenuMsgsTerm").focus(); }, 100);
        }
    },
    getData: function (pMenu, pRow) {
        lx.topMenu.fetchInProgress = true;
        apex.server.process("getTopMenuJson", {
            x01: pMenu,
            x02: (pRow ? pRow : 0),
            x03: (pMenu == 'S' ? $("#topMenuSearchTerm").val() : $("#topMenuMsgsTerm").val()),
            x04: (pMenu == 'N' && pRow ? lx.topMenu.notify.lastId : ""),
            x05: (pMenu == 'N' && pRow ? lx.topMenu.notify.lastTs : "")
        },{
            dataType: 'json',
            success: function (d) {
                lx.topMenu.fetchInProgress = false;
                if (pRow){
                    lx.topMenu.append(pMenu, d);
                } else {
                    switch (pMenu) {
                        case "P":
                            lx.topMenu.profile = d;
                            lx.topMenu.title.P = d.loc.title;//d.currentName;
                            break;
                        case "M":
                            lx.topMenu.msg = d;
                            lx.topMenu.title.M = d.loc.title;
                            break;
                        case "N":
                            lx.topMenu.notify = d;
                            lx.topMenu.title.N = d.loc.title;
                            lx.topMenu.reduceBadge(pMenu, d.unreadCnt);
                            break;
                        case "S":
                            lx.topMenu.search = d;
                            lx.topMenu.title.S = d.loc.title;
                            break;
                        case "SP":
                            lx.topMenu.support = d;
                            lx.topMenu.title.SP = d.loc.title;
                            break;
                        default:
                            break;
                    }
                    lx.topMenu.open(pMenu, true);
                }
            },
            error: function( jqXHR, textStatus, errorThrown ) {
                lx.topMenu.fetchInProgress = false;
                console.log( errorThrown );
            }
        });
    },
    append: function (pMenu, pData){
        var lRet = "";
        if (pData.rows.length == 0){
            $("#loadMore"+ pMenu).remove();
            return;
        }
        switch (pMenu){
            case "M": 
                for (let i = 0; i < pData.rows.length; i++) {
                    lRet += lx.topMenu.genMsgRow( pData.rows[i] );
                    lx.topMenu.msg.rows.push( pData.rows[i] );
                }
                break;
            case "N": 
                for (let i = 0; i < pData.rows.length; i++) {
                    lRet += lx.topMenu.genNotifyRow( pData.rows[i] );
                    lx.topMenu.notify.rows.push( pData.rows[i] );
                }
                if (pData.lastId) {
                    lx.topMenu.notify.lastId = pData.lastId;
                    lx.topMenu.notify.lastTs = pData.lastTs;
                }
                lx.topMenu.reduceBadge(pMenu, pData.unreadCnt);
                break;
            case "S": 
                for (let i = 0; i < pData.rows.length; i++) {
                    lRet += lx.topMenu.genSearchRow( pData.rows[i] );
                    lx.topMenu.search.rows.push( pData.rows[i] );
                }
                break;
            default: break;
        }
        $("#loadMore" + pMenu ).before(lRet);
    },
    increaseBadge: (pMenu, pCnt) => {
		console.log("pCnt = "+pCnt);
        var rCnt = parseInt(pCnt);
        if (rCnt === 0) return;
        var $badge = $(".lxTop_"+ pMenu +" .t-Button-badge");
        var cnt = parseInt( $badge.text() );
        if (isNaN(cnt)) cnt = 0;
        if (isNaN(rCnt)) rCnt = cnt;
        var cntNew = cnt + rCnt;
        $badge.text( cntNew );
        if (cntNew > 0) $badge.show();
    },
    reduceBadge: (pMenu, pCnt) => {
        var rCnt = parseInt(pCnt);
        if (rCnt === 0) return;
        var $badge = $(".lxTop_"+ pMenu +" .t-Button-badge");
        var cnt = parseInt( $badge.text() );
        if (isNaN(cnt)) cnt = 0;
        if (isNaN(rCnt)) rCnt = cnt;
        var cntNew = cnt - rCnt;
        $badge.text( cntNew );
        if (cntNew == 0) $badge.hide();
    },
    genProfile: function (pLogin){
        function genRow(row){
            let btns = "";
            if ( row.sub )      btns += lx.btn.gen({"label":lx.topMenu.profile.loc.view, "fa":"fas fawe-"+ (row.type == 'FOL' ? 'user' : 'building'),"link":row.view,"class":"t-Button--link t-Button--noLpad u-bold"});
            /*if (row.pubProfile) btns += lx.btn.gen({"label":lx.topMenu.profile.loc.view, "fa":"fas fawe-"+ (row.type == 'FOL' ? 'user' : 'building'),"js":"lxpDialog.close(this,'startupSwitch');","class":"t-Button--link t-Button--noLpad u-bold","hideIcon":"N"});
            if (row.switch)     btns += (lx.topMenu.profile.current == row.id ? 
                                            lx.btn.gen({"label":lx.topMenu.profile.loc.homepage, "fa":"fas fawe-home-alt",
                                                        "js":($v("P1_ID") == row.id && pLogin ? "lxpDialog.close(this,'startupSwitch');" : "redirect('"+row.hpLink+"')"),
                                                        "class":"t-Button--link t-Button--noLpad u-bold","hideIcon":"N"}) + 
                                            lx.btn.gen({"label": (row.type == 'COM' ? lx.topMenu.profile.loc.switchOrg : (row.id == 0 ? lx.topMenu.profile.loc.switch : lx.topMenu.profile.loc.switchFol) ), 
                                                        "fa":""+ (row.type == 'COM' ? 'fas fawe-building': 'fas fawe-user') +"","js":"redirect('"+row.ppLink+"')","class":"t-Button--link t-Button--noLpad u-bold","hideIcon":"N"}): 
                                            lx.btn.gen({"label":lx.topMenu.profile.loc.homepage, "fa":"fas fawe-home-alt",
                                                        "js":"lx.nav.switch("+ row.id +");","class":"t-Button--link t-Button--noLpad u-bold","hideIcon":"N"}) + 
                                            lx.btn.gen({"label": (row.type == 'COM' ? lx.topMenu.profile.loc.switchOrg : (row.id == 0 ? lx.topMenu.profile.loc.switch : lx.topMenu.profile.loc.switchFol) ), 
                                                        "fa":""+ (row.type == 'COM' ? 'fas fawe-building': 'fas fawe-user') +"","js":"lx.nav.switch("+ row.id +",null,null,'P');","class":"t-Button--link t-Button--noLpad u-bold","hideIcon":"N"})
                                        );*/
            //(row.group ? '<div class="box-group-title">'+ row.group +'</div>' : '')+
            return '<div class="box'+ (lx.topMenu.profile.current == row.id ? ' current' : (row.switch ? '" style="cursor:pointer;" onclick="lx.nav.switch('+ row.id +');' : '')) +'">'+
            '<div class="subBox">'+
				//'<div class="hdr' +(lx.topMenu.profile.current == row.id ? ' current' : '') +'">'+ row.label +'</div>'+// onclick="lx.nav.switch('+ row.id +');"
				'<div class="content"><div>'+
					lx.profile.genPic(row.img)+
					'</div><div class="txt">'+
						'<p class="name">'+ lx.util.escapeHTML(row.name) +'</p>'+// onclick="lx.nav.switch('+ row.id +');"
						(row.wp ? '<p class="wp">'+ row.wp +'</p>' : '')+// onclick="lx.nav.switch('+ row.id +');"
						(row.cpc ? '<p class="wp">'+ row.cpc +'</p>' : '')+// onclick="lx.nav.switch('+ row.id +');"
						btns+
						//(row.s_link && !pLogin ? lx.btn.gen({"label":lx.topMenu.profile.loc.subscription, "fa":"far fawe-credit-card","link":row.s_link,"class":"t-Button--link t-Button--noLpad u-bold","hideIcon":"N"}) : '')+
						//'<p class="link" onclick="lx.nav.switch('+ row.id +');">Switch</p>'+
					'</div>'+
				'</div>'+
			'</div>'+
            //'<div class="box_selected">'+ (lx.topMenu.profile.current == row.id ? lx.tran.get('SELECTED') : '') +'</div>'+
             (row.legit ?  row.legit : '')+
             (row.subscription_type ?  row.subscription_type : '')+
            // (lx.topMenu.profile.current == row.id ? '<div class="image_fa" '+ (row.subscription_type ?  'style="bottom:1.6rem;" ' : '') +'><i class="far fawe-check fa-xs" style="font-size:12px;display:block;"></i></div>' : '') +
        '</div>';
        }
        var lRet = "";
        for (var i = 0; i < lx.topMenu.profile.rows.length; i++) {
            var row = lx.topMenu.profile.rows[i];
            // skip members for post login popup
            if (pLogin && row.sub) continue;
            //row.img.path = lx.topMenu.profile.imgPath;
            lRet += genRow(row);
            if (i == 0 && lx.topMenu.pubProfile) lRet += genRow(lx.topMenu.pubProfile);
        }
        if (lx.topMenu.profile.rows.length >= lx.topMenu.profileSearchMin){
            return '<div class="hdrTitle">'+ lx.tran.get("TOP_MENU_ACCOUNT") +'</div><div class="topMenuSearch"><input id="topMenuProfileTerm" type="text" value="" placeholder="'+ lx.tran.get('SEARCH_CHAR') +'" onkeydown="lx.topMenu.searchKeyDown(event);" onkeyup="lx.topMenu.searchProfile(event);" autocomplete="off"/></div>'+
                    '<div class="topMenuResults" id="topMenuProfileResults">'+ lRet +'</div>';
        } else return lRet;
    },
    searchKeyDown: (e) => {
        console.log(e);
        if (e.target.id == "topMenuProfileTerm" && e.keyCode == 13 && e.ctrlKey){
            $("#topMenuProfileResults > .box:visible:first .t-Button").trigger( "click" );
            e.preventDefault();
        } else if (e.target.id == "topMenuMsgsTerm" && e.keyCode == 13 && e.ctrlKey){
            $("#topMenuMsgsResults > .box:visible:first .t-Button").trigger( "click" );
            e.preventDefault();
        } else if (e.keyCode == 13) e.preventDefault();
        return false;
    },
    searchProfile: (e) => {
        //console.log(e);
        if (e.keyCode == 13 && e.ctrlKey){
            $("#topMenuProfileResults > .box:visible:first .t-Button").trigger( "click" );
            e.preventDefault();
            return false;
        }
        var term = e.target.value.toLowerCase();
        if (term.length = "") {
            $("#topMenuProfileResults > .box").show();
			$(".box-group-title").show();
		} else {
            $("#topMenuProfileResults > .box").each( function () {
                var $box = $(this);
                var name = $box.find(".name").text().toLowerCase();
                if (name.includes(term)) $box.show();
                else {$box.hide(); $(".box-group-title").hide();}
            });
        }
        
        if (e.keyCode == 13) e.preventDefault();
        return false;
    },
    genMsg: function (){
		
       // alert('UNUTRA1');
        var lRet = "";
        if (lx.topMenu.msg.rows.length == 0){
            return lRet + '<div class="box">'+ lx.tran.get('NO_MESSAGES') +'</div>';
        } else {
            for (let i = 0; i < lx.topMenu.msg.rows.length; i++) {
                lRet += lx.topMenu.genMsgRow( lx.topMenu.msg.rows[i] );
            }
            return '<div class="hdrTitle">'+ lx.tran.get("TOP_MENU_CHATS") +'</div><div class="topMenuSearch"><input id="topMenuMsgsTerm" type="text" value="" placeholder="'+ lx.tran.get('SEARCH_MSG') +/*+ lx.topMenu.msg.loc.minLetters +*/'" onkeydown="lx.topMenu.searchKeyDown(event);" onkeyup="lx.topMenu.searchMsgs(this);" /></div>'+
            '<div class="topMenuResults" id="topMenuMsgsResults">'+ lRet + '<div id="loadMoreM" class="box loadMore">'+ lx.topMenu.loading +'</div></div>';//  onclick="lx.topMenu.getData(\'M\', lx.topMenu.msg.rows.length)"
        }
    },
    genMsgRow: function (row){
        var lRet;
        //row.img.path = lx.topMenu.msg.imgPath;
        let lSubjectImgs = null;
        if (row.recipients.length == 1) {
            lSubjectImgs = '<div class="MsgImg1">'+ (row.recipients[0].img ? lx.profile.genPic(row.recipients[0].img) :"") +'</div>';
        } else if (row.recipients.length > 1) {
            row.recipients[0].img.size = 'S';
            row.recipients[1].img.size = 'S';
            lSubjectImgs =  '<div class="MsgImg1">'+ lx.profile.genPic(row.recipients[0].img) +'</div>'+
                            '<div class="MsgImg2">'+ lx.profile.genPic(row.recipients[1].img) +'</div>';
        }

       // lRet = '<div class="box'+ (row.unread || lx.msg.newChats[row.id] ? ' hl' : '') +'" onclick="'+ row.js +';" style="cursor:pointer;">'+
		lRet = '<div class="box'+ (row.unread || lx.msg.newChats[row.id] ? ' hl' : '') +'" onclick="'+ (document.body.clientWidth < lx.msg.mobileBreakpoint || lx.msg.full ? row.js2 : row.js) +';" style="cursor:pointer;">'+
                    //'<div class="hdr">'+ row.subject +'</div>'+
					'<div class="subBox">'+
						'<div class="content"><div class="msgImages">'+
							lSubjectImgs+//lx.profile.genPic( row.img )+
							(row.unread || lx.msg.newChats[row.id] ? '<div class="chatBadge"></div>' : '') +
							'</div><div class="txt">'+
								'<p class="name">'+ lx.util.escapeHTML(row.subject) +'</p>'+
								'<p class="recipients">'+ (row.recipients.length > 0 ? lx.util.escapeHTML(row.recipients.map(function(e){return e.fname;}).join(", ")) : "-") +'</p>'+
								//'<p class="msg" onclick="'+ row.js +';">'+  (row.dontEscapeMsg ? row.msg : lx.util.escapeHTML(row.msg).replace(/(?:\r\n|\r|\n)/g, "<br />")) +'</p>'+
								'<p class="ts"><i class="far fawe-clock" style="font-size:1.2rem;"></i> '+ row.ts +' '+ lx.util.escapeHTML(row.senderName) + '</p>'+
								//lx.btn.gen({"label":lx.topMenu.msg.loc.viewConversation +' ('+ row.msgCnt +')', "fa":"fas fawe-comments","js":row.js,"class":"t-Button--link t-Button--noLpad u-bold t-Button--lessRpad"}) +
								//lx.btn.gen({"label":lx.topMenu.msg.loc.archive, "fa":"fas fawe-archive","js":'lx.msg.isDeletedDD('+ row.id +',this,false);',"class":"t-Button--link t-Button--preDot u-bold"}) +
								//<i class="fas fawe-archive" onclick="lx.msg.isDeleted(1923,1074);" title="Archive this message"></i>
								//'<a class="link" href="'+ row.link +'">'+ lx.topMenu.msg.loc.viewConversation +' ('+ row.msgCnt +')</a>'+
							'</div>'+
						'</div>'+
					'</div>'+
                '</div>';
        return lRet;
    },
    searchMsgs: (pThis) => {
        var term = pThis.value;
        if (term.length < 3) {
            $("#topMenuMsgsResults").html('');/*<div class="box msg">'+ lx.topMenu.search.loc.minLetters +'</div>*/
            if (term.length != 0) return;
        } else {
            $("#topMenuMsgsResults").html('<div class="box loadMore">'+ lx.topMenu.loading +'</div>');
        }
        
        lx.topMenu.fetchInProgress = true;
        apex.server.process("getTopMenuJson", {
            x01: "M",
            x02: 0,
            x03: term
        },{
            dataType: 'json',
            success: (d) => {
                lx.topMenu.fetchInProgress = false;
                lx.topMenu.msg.rows = d.rows;
                var lRet = "";
                // generate rows
                for (let i = 0; i < lx.topMenu.msg.rows.length; i++) {
                    lRet += lx.topMenu.genMsgRow( lx.topMenu.msg.rows[i] );
                }
                // No results or load more
                if (d.rows.length == 0) {
                    lRet = '<div class="box msg">'+ lx.topMenu.msg.loc.noResults +'</div>';
                } else if (d.rows.length >= (lx.topMenu.msg.pageRows-1) ) {
                    lRet += '<div id="loadMoreM" class="box loadMore">'+ lx.topMenu.loading +'</div>';// onclick="lx.topMenu.getData(\'M\', lx.topMenu.msg.rows.length)"
                }
                // replace result HTML
                $("#topMenuMsgsResults").html(lRet);
                // start load more observer
                if (d.rows.length >= (lx.topMenu.msg.pageRows-1) ) lx.topMenu.observeMoreMsg.observe( document.querySelector("#loadMoreM") );
            },
            error: function( jqXHR, textStatus, errorThrown ) {
                lx.topMenu.fetchInProgress = false;
                console.log( errorThrown );
            }
        });
    },
    genNotify: function (){
        var lRet = "";
        for (let i = 0; i < lx.topMenu.notify.rows.length; i++) {
            lRet += lx.topMenu.genNotifyRow( lx.topMenu.notify.rows[i] );
        }
        return '<div class="hdrTitle">'+ lx.tran.get("TOP_MENU_ACTIVITY") +'</div>' + lRet + '<div id="loadMoreN" class="box loadMore">'+ lx.topMenu.loading +'</div>';//  onclick="lx.topMenu.getData(\'N\', lx.topMenu.notify.rows.length)"
    },
    genNotifyRow: function (row){
        var lRet;
        //row.img.path = lx.topMenu.notify.imgPath;
        lRet = '<div class="box">'+
					'<div class="subBox">'+
						'<div class="hdr lxNotifyType__'+ row.type +'" '+ (row.switchId ? ' onclick="lx.nav.switch('+row.switchId+');"' : '') +'>'+ row.typeName +'</div>'+
						'<div class="content">'+ '<div' + (row.switchId ? ' onclick="lx.nav.switch('+row.switchId+');">' : '>') +
							lx.profile.genPic( row.img )+//'<div class="img"></div>'+
							'</div><div class="txt">'+
								'<p class="recipients"' + (row.switchId ? ' onclick="lx.nav.switch('+row.switchId+');"' : '')+'>'+ row.person +'</p>'+
								'<p class="msg"' + (row.switchId ? ' onclick="lx.nav.switch('+row.switchId+');"' : '')+'>'+ row.msg +'</p>'+
								(row.info ? '<p class="msg"' + (row.switchId ? ' onclick="lx.nav.switch('+row.switchId+');"' : '')+'>'+ row.info +'</p>' : '') +
								/*(row.link ? '<p class="link"'+ ((row.link.substr(0,3) == 'f?p' || row.link.substr(0,6) == '/apex/') ? '><a href="'+ row.link +'">'+ row.linkTxt +'</a>' : ' onclick="'+ row.link +'">'+ row.linkTxt) +'</p>' : '') +*/
								(row.link ? '<p class="link"' + (row.switchId ? ' onclick="lx.nav.switch('+row.switchId+');"' : '')+'>'+ row.linkTxt +'</p>' : '') +
								'<p class="ts"'+ (row.switchId ? ' onclick="lx.nav.switch('+row.switchId+');"' : '')+ '>' + row.ts +'</p>'+
								(row.switchId ? lx.btn.gen({"label":lx.tran.get('SWITCH_TO'),"fa":"far fawe-random","js":"lx.nav.switch("+ row.switchId +");","class":"t-Button--link t-Button--noLpad u-bold","hideIcon":"N"}) : '') +
								//(row.switchId ? '<p class="link switch" onclick="lx.nav.switch('+ row.switchId +');"><i class="far fawe-exchange"></i>'+ row.switchName +'</p>' : '') +
							'</div>'+
						'</div>'+
					'</div>'+
                '</div>';
        return lRet;
    },
    searchTerm: (pThis) => {
        var term = pThis.value;
        if (term.length < 3) {
            $("#topMenuSearchResults").html('');/*<div class="box msg">'+ lx.topMenu.search.loc.minLetters +'</div>*/
            return;
        } else {
            $("#topMenuSearchResults").html('<div class="box loadMore">'+ lx.topMenu.loading +'</div>');
        }
        
        lx.topMenu.fetchInProgress = true;
        apex.server.process("getTopMenuJson", {
            x01: "S",
            x02: 0,
            x03: term
        },{
            dataType: 'json',
            success: (d) => {
                lx.topMenu.fetchInProgress = false;
                lx.topMenu.search.rows = d.rows;
                var lRet = "";
                // generate rows
                for (let i = 0; i < lx.topMenu.search.rows.length; i++) {
                    lRet += lx.topMenu.genSearchRow( lx.topMenu.search.rows[i] );
                }
                // No results or load more
                if (d.rows.length == 0) {
                    lRet = '<div class="box msg">'+ lx.topMenu.search.loc.noResults +'</div>';
                } else if (d.rows.length >= lx.topMenu.search.pageRows) {
                    lRet += '<div id="loadMoreS" class="box loadMore">'+ lx.topMenu.loading +'</div>';// onclick="lx.topMenu.getData(\'S\', lx.topMenu.search.rows.length)"
                }
                // replace result HTML
                $("#topMenuSearchResults").html(lRet);
                // start load more observer
                if (d.rows.length >= lx.topMenu.search.pageRows) lx.topMenu.observeMoreSearch.observe( document.querySelector("#loadMoreS") );
            },
            error: function( jqXHR, textStatus, errorThrown ) {
                lx.topMenu.fetchInProgress = false;
                console.log( errorThrown );
            }
        });
    },
    genSearch: () => {
        return '<div class="hdrTitle">'+ lx.tran.get("SEARCH_PUB_PROFILES") +'</div><div class="topMenuSearch"><input id="topMenuSearchTerm" type="text" value="" placeholder="'+ lx.topMenu.search.loc.minLetters +'" onkeydown="lx.topMenu.searchKeyDown(event);" onkeyup="lx.topMenu.searchTerm(this);" /></div>'+
               '<div class="topMenuResults" id="topMenuSearchResults"></div>';/*<div class="box msg">'+ lx.topMenu.search.loc.minLetters +'</div>*/
    },
    genSearchRow: (row) => {
        var lRet = "";
		console.log(row.legit);
        //row.img.path = lx.topMenu.search.imgPath;
        lRet = '<div class="box">'+//onclick="$(this).find(\'.t-Button > ul\').toggle();"
					'<div class="subBox">'+
						//'<div class="hdr">'+ row.label +'</div>'+
						'<a class="content" href="'+ row.profileLink +'">'+
							lx.profile.genPic( row.img )+
							'<div class="txt">'+
								'<p class="name">'+ lx.util.escapeHTML(row.name) +'</p>'+
								(row.short ? '<p class="wp">'+ row.short +'</p>' : '')+
								//'<p class="ts">'+ lx.topMenu.search.loc.joined.replace('#1#', row.joined) +'</p>'+
								'<div>'+
								//(row.link ? lx.btn.gen({"label":lx.tran.get('PROFILE'),"fa":""+ (row.type == 'FOL' ? 'fas fawe-user' : 'fas fawe-building' ) +"","link":row.link,"class":"t-Button--link t-Button--noLpad u-bold t-Button--upperL t-Button--lessRpad","hideIcon":"N"}): '')+
								//(row.msgLink ? lx.btn.gen({"label":lx.tran.get('SEND_MSG'),"fa":"fas fawe-comments","link":row.msgLink,"class":"t-Button--link t-Button--preDot u-bold t-Button--upperL","hideIcon":"N"}): '')+
								'</div>' +
							'</div>'+
						'</a>'+
                        (row.btn ? row.btn : '') +
					'</div>'+
					(row.legit ?  row.legit : '')+
                '</div>';
        return lRet;
    },
    genSupport: () => {
        /*var lBtns = "";
        for (let j = 0; j < lx.topMenu.support.btn.length; j++) {
            lBtns += lx.btn.gen( lx.topMenu.support.btn[j] );
        }
        lBtns = '<div class="box"><div class="infoMiddle">'+ lx.topMenu.support.loc.info +'</div>'+ lBtns +'</div>';*/
        
        var lRet = "";
        for (var i = 0; i < lx.topMenu.support.rows.length; i++) {
            var row = lx.topMenu.support.rows[i];
            if (row.faq.charAt(0) == '_') lRet += '<div class="sectionHdr">'+ row.faq.replace('_','') +'</div>';
            else lRet += '<a class="entry" href="'+ row.link +'" target="_blank">'+ row.faq +'</a>';
        }
        return /*lBtns + */'<div class="faq"><div class="hdr">'+ lx.topMenu.support.loc.hdr +'</div>'+ lRet +'</div>';
    },
    startupSwitch: () => {
        apex.server.process("getTopMenuJson", {
            x01: 'P',
            x02: 0
        },{
            dataType: 'json',
            success: function (d) {
                lx.topMenu.profile = d;
                lx.topMenu.title.P = d.loc.title;
                lx.topMenu.pubProfile = d.pubProfile;
                if (d.rows.length > 1 || d.pubProfile){
                    let html = '<div class="lxTop"><div class="content">'+ lx.topMenu.genProfile(true) +'</div></div>';
                    lx.dialog.open({id:"startupSwitch", maxWidth: "400px", html: html}); /*title: "<b>"+d.loc.afterLoginTitle+"</b>"*/
                    lx.topMenu.profile = null;
                    lx.topMenu.pubProfile = null;
                }
            },
            error: function( jqXHR, textStatus, errorThrown ) {
                lx.topMenu.fetchInProgress = false;
                console.log( errorThrown );
            }
        });
    }
};